import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

let firstRender = false
const Product = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['product', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [masterOptions, setMasterOptions] = useState({
    common_status: [],
    product_unit: [],
    product_type: [],
    product_group: [],
    vehicle_status: [],
    supplier: [],
    customer: []
  })

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status,product_unit,product_type,product_group,supplier,customer")
        .then((res: any) => {
          let common_status = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          let product_unit = res.result.product_unit.map((item) => ({ label: item.unit_name, value: item.unit_id }))
          let product_type = res.result.product_type.map((item) => ({ label: item.product_type_name, value: item.product_type_id }))
          let product_group = res.result?.product_group.map((item) => ({ label: item.group_name, value: item.group_id }))
          let supplier = res.result?.supplier.map((item) => ({ label: item.supplier_name, value: item.supplier_code }))
          let customer = res.result?.customer.map((item) => ({ label: item.cust_name, value: item.cust_id }))

          setMasterOptions({
            ...masterOptions,
            common_status,
            product_unit,
            product_type,
            product_group,
            supplier,
            customer
          })
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  return <FormMaster
    title={t('product_information')}
    tableConfig={{
      key: "id",
      apiPath: "product/list",
      allowDelete: {
        visible: true,
        key: "product_id",
        apiPath: "product/delete",
        paramType: "param"
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'product_code',
          caption: t('product_code'),
          allowFiltering: true
        },
        {
          dataField: 'product_name',
          caption: t('product_name'),
          allowFiltering: true
        },
        {
          dataField: 'material_code',
          caption: t('material_code'),
          allowFiltering: true
        },
        {
          dataField: 'type_name',
          caption: t('product_type'),
          allowFiltering: true
        },
        {
          dataField: 'group_name',
          caption: t('product_group'),
          allowFiltering: true
        },
        {
          dataField: 'unit_name',
          caption: t('product_unit'),
          allowFiltering: true
        },
        {
          dataField: 'dim_w',
          caption: t('width_cm'),
        },
        {
          dataField: 'dim_d',
          caption: t('length_cm'),
        },
        {
          dataField: 'dim_h',
          caption: t('height_cm'),
        },
        {
          dataField: 'weight',
          caption: t('weight_kg'),
        },
        {
          dataField: 'dimension',
          caption: t('volume_m3'),
        },
        {
          dataField: 'cust_code',
          caption: t('customer_code'),
        },
        {
          dataField: 'cust_name',
          caption: t('customer_name'),
        },
        {
          dataField: 'status_name',
          caption: t('status'),
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: "แก้ไขโดย"
        }
      ],
      exportExcel: {
        fileName: t('product_information'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('product_code'), value: 'product_code' },
          { label: t('product_name'), value: 'product_name' },
          { label: t('material_code'), value: 'material_code' },
          { label: t('product_type'), value: 'type_name' },
          { label: t('product_group'), value: 'group_name' },
          { label: t('product_unit'), value: 'unit_name' },
          { label: t('width_cm'), value: 'dim_w' },
          { label: t('length_cm'), value: 'dim_d' },
          { label: t('height_cm'), value: 'dim_h' },
          { label: t('weight_kg'), value: 'weight' },
          { label: t('volume_m3'), value: 'dimension' },
          { label: t('customer_code'), value: 'cust_code' },
          { label: t('customer_name'), value: 'cust_name' },
          { label: t('status'), value: 'status_name' },
          { label: t('product_edit'), value: 'updated_by' },
        ],
      }
    }}
    formData={{
      group_id: "",
      type_id: "",
      product_code: "",
      material_code: "",
      description: "",
      product_name: "",
      dim_h: "",
      dim_w: "",
      dim_d: "",
      weight: "",
      unit_id: "",
      dimension: "",
      supplier_code: "",
      supplier_name: "",
      cust_id: "",
      status: "Y"
    }}
    modalConfig={{
      screenName: "product",
      visible: true,
      title: t('product_information'),
      required: ["product_code", "product_name", "type_id", "group_id", "unit_id"],
      fieldTypeNumber: [],
      paramName: "product_id",
      masterData: { supplier: masterOptions.supplier },
      apiPath: {
        "get": '',
        "post": 'product/add',
        "put": 'product/update'
      },
      elements: [
        {
          fieldName: "product_code",
          label: t('product_code'),
          placeholder: t('product_code'),
          required: true,
          inputType: "text"
        },
        {
          fieldName: "material_code",
          label: t('material_code'),
          placeholder: t('material_code'),
          required: false,
          inputType: "text"
        },
        {
          fieldName: "product_name",
          label: t('product_name'),
          placeholder: t('product_name'),
          required: true,
          inputType: "text"
        },
        {
          fieldName: "type_id",
          label: t('product_type'),
          placeholder: t('product_type'),
          inputType: "select",
          required: true,
          options: masterOptions.product_type
        },
        {
          fieldName: "group_id",
          label: t('product_group'),
          placeholder: t('product_group'),
          inputType: "select",
          required: true,
          options: masterOptions.product_group
        },
        {
          fieldName: "unit_id",
          label: t('product_unit'),
          placeholder: t('product_unit'),
          inputType: "select",
          required: true,
          options: masterOptions.product_unit
        },
        {
          fieldName: "dim_w",
          label: t('width_cm'),
          placeholder: t('width_cm'),
          inputType: "number"
        },
        {
          fieldName: "dim_d",
          label: t('length_cm'),
          placeholder: t('length_cm'),
          inputType: "number"
        },
        {
          fieldName: "dim_h",
          label: t('height_cm'),
          placeholder: t('height_cm'),
          inputType: "number"
        },
        {
          fieldName: "weight",
          label: t('weight_kg'),
          placeholder: t('weight_kg'),
          inputType: "number"
        },
        {
          fieldName: "dimension",
          label: t('volume_m3'),
          placeholder: t('volume_m3'),
          inputType: "number"
        },
        {
          showSearch: false,
          fieldName: "status",
          label: t('status'),
          inputType: "select",
          defaultValue: "Y",
          options: masterOptions.common_status
        },
        {
          fieldName: "supplier_code",
          allowClear: true,
          label: "Supplier",
          placeholder: "Supplier",
          inputType: "select",
          options: masterOptions.supplier
        },
        {
          fieldName: "cust_id",
          allowClear: true,
          label: t('customer'),
          placeholder: t('customer'),
          inputType: "select",
          options: masterOptions.customer
        }
      ]
    }}
  />
}))

export default Product